export default __webpack_public_path__ + "static/media/cont5.c870ce74.jpg";